import { CardContent } from "@/components/ui/card";
import { X, Lightbulb } from "lucide-react";
import React from "react";

interface SetInfoHelperProps {
  onClose: () => void;
}

const DeleteSetHelper: React.FC<SetInfoHelperProps> = ({ onClose }) => (
  <CardContent className="-mt-2 mb-4 py-0">
    <div className="flex flex-col px-4 py-6 rounded-xl relative bg-accent-fg-warm">
      <button
        onClick={onClose}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-white transition-colors text-tx-dark"
        aria-label="Close helper"
      >
        <X size={16} />
      </button>
      <div className="flex items-start w-full text-left pr-3">
        <Lightbulb size={20} className="mr-3 shrink-0 mt-0.5 text-tx-dark" />
        <p className="text-sm text-tx-dark">
          See something wrong? Just tap any record to remove it.
        </p>
      </div>
    </div>
  </CardContent>
);

export default DeleteSetHelper;
